export interface AddEmployee {
  user_first_name: string;
  user_last_name: string;
  role: string;
  manager_id: string;
  emp_id: string;
  user_designation: string;
  dojoining: string;
  user_mobile: string;
  user_email: string;
  user_skypeid: string;
  doBirth: string;
  doanniversary: string;
  profile_picture: string;
  id_proof: string;
  address1: string;
  address2: string;
  country: string;
  state: string;
  city: string;
  zipcode: string;
  user_department: string;
}

export interface EmployeeDetail {
  emp_id: string;
  id_proof: string;
  profile_picture: string;
  status: string;
  usr_address: string;
  usr_address2: string;
  usr_country: string;
  usr_state: string;
  usr_city: string;
  usr_zipcode: string;
  usr_customer_track_id: string;
  usr_designation: string;
  usr_doa: string;
  usr_dob: string;
  usr_doj: string;
  usr_email: string;
  usr_empID: string;
  usr_manager_id: string;
  usr_mobile: string;
  user_first_name: string;
  user_last_name: string;
  usr_role_track_id: string;
  usr_skype_id: string;
  usr_team_track_id: string;
  usr_type: string;
  employee_id: string;
  user_fullname: string;
  user_department: SVGStringList;
  wfh_status?: string;
  limit?: number;
  offset?: number;
  total_records?: number
}

export interface ResourceReport {
  user_id: string,
  pdf_link: string;
  usr_role_track_id: string,
  usr_empID: string,
  user_first_name: string,
  user_last_name: string,
  usr_designation: string,
  profile_picture: string,
  id_proof: string,
  status: string,
  working_hours: number,
  utilized_hours: number,
  leave_hours: number,
  upcomingleave_hours: number,
  remaining_hours: number,
  monthly_utilization_percentage: number,
  projectDetails: resourceData[],
}

export interface resourceData {
  project_track_id: string,
  task_track_id: string,
  project_name: string,
  project_status: string,
  total_time_spent: string,
  budgeted_hours: string,
  project_progress: string
}

export interface GenerateResourceReport {
  reportfromDate: string;
  reporttoDate: string;
}